"use client";

import type { ReactNode } from "react";
import { Badge } from "../../elements/badge/badge";
import { Text } from "../../elements/text/text";

export interface ProductPriceInfoProps {
  priceInfo: {
    label: string;
    value: string;
    showRrp?: boolean;
    rrpValue?: string;
    /** Optional label for the RRP block (defaults to "RRP") */
    rrpLabel?: string;
    discountLabel?: string;
    discountPrice?: string;
    isNetPriced?: boolean /** Control whether to show the variant price label and value (defaults to true) */;
    showVariantPrice?: boolean;
  };
  /** Optional label text to render when price is net-priced (e.g. "NET") */
  tagNetPriced?: string;
}

export function ProductPriceInfo(
  props: Readonly<ProductPriceInfoProps>
): ReactNode {
  return (
    <div className="flex flex-col">
      {/* price label and values */}
      <div className="flex flex-col items-start gap-1">
        {props.priceInfo.showVariantPrice !== false && (
          <div className="flex items-center gap-2">
            <Text variant="body-sm">{props.priceInfo.label}</Text>
          </div>
        )}

        {props.priceInfo.showVariantPrice !== false && (
          <div className="flex items-center gap-1">
            <Text
              style={props.priceInfo.discountLabel ? "line-through" : undefined}
              variant="body-sm-bold"
            >
              {props.priceInfo.value}
            </Text>
            {props.priceInfo.isNetPriced && props.tagNetPriced && (
              <Badge size="sm" text={props.tagNetPriced} variant="default" />
            )}
            {props.priceInfo.discountLabel && (
              <Badge
                size="sm"
                text={props.priceInfo.discountLabel}
                variant="outline"
              />
            )}
          </div>
        )}

        {props.priceInfo.showVariantPrice !== false &&
          props.priceInfo.discountPrice && (
            <Text color="red" variant="body-sm-bold">
              {props.priceInfo.discountPrice}
            </Text>
          )}
      </div>

      {/* RRP block */}
      {props.priceInfo.showRrp && props.priceInfo.rrpValue && (
        <div className="flex flex-col items-start gap-1">
          <Text variant="body-sm">{props.priceInfo.rrpLabel}</Text>
          <Text variant="body-sm-bold">{props.priceInfo.rrpValue}</Text>
        </div>
      )}
    </div>
  );
}
